export default "__VITE_ASSET__BtzeNg4J__"